import styles from "./VotingChart.module.scss";
import { useRef } from "react";
import colors from "../styles/_colors.scss";
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";
import VotingResultsFetcher from "./VotingResultsFetcher";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function VotingChart(props) {
  const chartRef = useRef();
  const chartWrapperRef = useRef();
  function newDataHandler(loadedVotingResults) {
    let votingTuples = [];
    for (let word in loadedVotingResults) {
      votingTuples.push([word, loadedVotingResults[word]]);
    }
    votingTuples.sort((word1, word2) => word2[1] - word1[1]);
    votingTuples = votingTuples.slice(0, props.limit);
    const labels = votingTuples.map((item) => item[0]);
    const datapoints = votingTuples.map((item) => item[1]);
    chartRef.current.data.labels = labels;
    chartRef.current.data.datasets[0].data = datapoints;
    const chartWrapperStyleString = `max-height:${(
      100 +
      40 * labels.length
    ).toString()}px;\ndisplay:${datapoints.length > 0 ? "block" : "none"};\n`;
    const noVotesStyleString = `display: ${datapoints.length > 0 ? "none" : "block"};\n`;
    document.getElementsByClassName(styles.chartWrapper)[0].style = chartWrapperStyleString ;
    document.getElementsByClassName(styles.noVotes)[0].style = noVotesStyleString;
    chartRef.current.update();
  }

  const options = {
    indexAxis: "y",
    animation: true,
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    scales: {
      x: {
        position: "top",
        ticks: {
          precision: 0,
        },
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display:false
      },
      title: {
        display: true,
        text: `Top ${props.limit} results`,
        font:{
          size:24
        }
      },
    },
  };

  const startingData = {
    labels: [],
    datasets: [
      {
        label: "Number of votes",
        data: [],
        borderColor: colors.secondary,
        backgroundColor: colors.secondary + "88",
      },
    ],
  };

  return (
    <div>
      <div className={styles.votingResultsWrapper}>
        <div className={styles.chartWrapper} ref={chartWrapperRef}>
          <Bar options={options} data={startingData} ref={chartRef} />
          <VotingResultsFetcher
            onDataFetched={newDataHandler}
            votingId={props.votingId}
          />
          {/* Chart.js has a bug where maintainAspectRatio works only if there is element with content next to it. WEIRD */}
          <div className={styles.invisible}>.</div>
        </div>
        <div className={styles.noVotes}>
          <h1>There are no votes yet! Be first!</h1>
        </div>
      </div>
    </div>
  );
}

function areEqual(prevProps, nextProps) {
  return true;
}

export default React.memo(VotingChart, areEqual);
